import { isExistingSiteEntryMode } from 'config/entry-mode';
import { useProductCatalog } from 'hooks/useProductCatalog';
import { useProductSelection } from 'hooks/useProductSelection';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import { MAX_SELECTED_PRODUCTS_DEFAULT } from 'utils/product-selection';
import { ProductPickerGrid } from './ProductPickerGrid';

export const SelectProductsStepOptions: FC = () => {
  const entryMode = useAppStore((state) => state.entryMode);
  const { products, isLoading } = useProductCatalog();
  const isExistingSiteMode = isExistingSiteEntryMode(entryMode);
  const maxSelectedProducts = isExistingSiteMode ? products.length : MAX_SELECTED_PRODUCTS_DEFAULT;
  const { selectedProductIds, toggleProduct } = useProductSelection(maxSelectedProducts);

  return (
    <ProductPickerGrid
      products={products}
      selectedProductIds={selectedProductIds}
      onToggle={toggleProduct}
      maxSelectedProducts={maxSelectedProducts}
      isLoading={isLoading}
    />
  );
};
